import api from "./instance";

export default {
  getPushNotifications: (token, page) =>
    api
      .get(`/notification/get-push-notifications?page=${page}&perPage=10`, {
        headers: { Authorization: token }
      })
      .then(res => res),
  scheduleNotification: (token, body) =>
    api
      .post(`/notification/send-push-notification`, body, {
        headers: { Authorization: token }
      })
      .then(res => res)
};
